import { useEffect, useState } from 'react';

const LOGO_URL = 'https://static.readdy.ai/image/358c420565fea72b91269b0160885e8f/345a23f26c025716610c41033cbf85f6.png';
const CTA_LINK = 'https://equilibradamente.base44.app/';

export default function TopNavBar() {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <header
      className="fixed top-0 left-0 right-0 z-50 transition-all duration-300"
      style={{
        background: scrolled ? 'rgba(6,13,24,0.95)' : 'transparent',
        backdropFilter: scrolled ? 'blur(12px)' : 'none',
        borderBottom: scrolled ? '1px solid rgba(0,200,232,0.12)' : 'none',
      }}
    >
      <div className="max-w-6xl mx-auto px-6 py-3 flex items-center justify-between">
        {/* Logo */}
        <div className="flex items-center gap-3">
          <div className="w-12 h-12 flex items-center justify-center flex-shrink-0">
            <img
              src={LOGO_URL}
              alt="EquilibradaMente™ logo"
              className="w-12 h-12 object-contain rounded-lg"
            />
          </div>
          <div className="hidden sm:block">
            <span className="text-white font-semibold text-sm tracking-wide leading-none block">
              EQUILIBRADA<span style={{ color: '#F5A520' }}>MENTE</span>™
            </span>
            <span className="text-xs tracking-widest" style={{ color: '#00C8E8' }}>
              CUIDE DA SUA MENTE
            </span>
          </div>
        </div>

        {/* CTA Button */}
        <a
          href={CTA_LINK}
          target="_blank"
          rel="noreferrer"
          className="whitespace-nowrap text-sm font-semibold px-5 py-2 rounded-full cursor-pointer"
          style={{
            background: 'linear-gradient(135deg, #00C8E8, #00A3C0)',
            color: '#060D18',
            transition: 'transform 0.2s, box-shadow 0.2s',
          }}
          onMouseEnter={e => {
            (e.currentTarget as HTMLAnchorElement).style.transform = 'translateY(-1px)';
            (e.currentTarget as HTMLAnchorElement).style.boxShadow = '0 4px 20px rgba(0,200,232,0.4)';
          }}
          onMouseLeave={e => {
            (e.currentTarget as HTMLAnchorElement).style.transform = 'translateY(0)';
            (e.currentTarget as HTMLAnchorElement).style.boxShadow = 'none';
          }}
        >
          Iniciar sessão gratuita
        </a>
      </div>
    </header>
  );
}